import { RX0008 } from "../rxTypeCode";

export const SET_PURPOSEOFTRANSFER = "SET_PURPOSEOFTRANSFER" + RX0008;
export const SET_PURPOSEOFTRANSFERNAME = "SET_PURPOSEOFTRANSFERNAME" + RX0008;

export const GET_ALLOWED_PURPOSEOFTRANSFERS_REQUEST = "GET_ALLOWED_PURPOSEOFTRANSFERS_REQUEST" + RX0008;
export const GET_ALLOWED_PURPOSEOFTRANSFERS_SUCCESS = "GET_ALLOWED_PURPOSEOFTRANSFERS_SUCCESS" + RX0008;
export const GET_ALLOWED_PURPOSEOFTRANSFERS_FAILURE = "GET_ALLOWED_PURPOSEOFTRANSFERS_FAILURE" + RX0008;
export const CLEANUP = "CLEANUP" + RX0008;